import React from 'react';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isAuthenticated, loading, login } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#C5A059] mb-4"></div>
          <p className="text-white text-lg font-manrope" data-testid="protected-route-loading">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="w-16 h-16 bg-gradient-to-r from-[#C5A059] to-[#E5C578] rounded-lg flex items-center justify-center font-bold text-black text-2xl mx-auto mb-6">
            DG
          </div>
          <h1 className="text-3xl font-bold font-manrope text-white mb-4" data-testid="join-community-heading">Join the Community</h1>
          <p className="text-gray-400 mb-6">Sign in with Google to access the forum, post content, and join discussions.</p>
          <button
            onClick={login}
            className="inline-flex items-center gap-2 bg-[#C5A059] text-black px-8 py-3 rounded-sm font-semibold hover:bg-[#D4AF37] transition-all shadow-[0_0_15px_rgba(197,160,89,0.3)] hover:shadow-[0_0_25px_rgba(197,160,89,0.5)]"
            data-testid="google-sign-in-btn"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </button>
          <p className="text-gray-500 text-sm mt-6">
            <a href="/" className="text-[#C5A059] hover:text-[#D4AF37]">Back to Home</a>
          </p>
        </div>
      </div>
    );
  }

  if (adminOnly && user.role !== 'admin') {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <h1 className="text-3xl font-bold font-manrope text-white mb-4" data-testid="access-denied-heading">Access Denied</h1>
          <p className="text-gray-400 mb-6">You need administrator privileges to access this page.</p>
          <a href="/forum" className="inline-block bg-[#C5A059] text-black px-6 py-3 rounded-sm font-semibold hover:bg-[#D4AF37] transition-all" data-testid="go-to-forum-link">
            Go to Forum
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
